import { useConnectModal } from '@lair-finance/wallet'
import { useResponsive } from '@/shared/hooks/useResponsive.ts'
import { LiffSDK } from '@/modules/game/shared/lib/sdk/liff.ts'
import { useDappPortalLogin } from '@/modules/game/features/dapp-portal-auth/hooks/useDappPortalLogin.ts'
import { Button } from '@lair-finance/uikit'

export function ConnectButton() {
  const isTablet = useResponsive('tablet')
  const { openConnectModal } = useConnectModal()
  const dappPortalLogin = useDappPortalLogin()

  async function handleClick() {
    if (LiffSDK.isInClient()) {
      await dappPortalLogin()
    } else {
      openConnectModal?.()
    }
  }

  return (
    <Button size={isTablet ? 'md' : 'sm'} onClick={handleClick}>
      Connect Wallet
    </Button>
  )
}
